import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import AppNavigator from "../../Navigators/AppNavigator";
import { initAuth } from "../../Modules/auth/startup";
import { isLoggedIn } from "../../Stores/redux/Persist/Selectors";

class RootScreen extends Component {
  async componentDidMount() {
    if (this.props.isLoggedIn) {
      initAuth();
    }
  }

  render() {
    return (
      <AppNavigator
        {...{ user: this.props.user, impersonator: this.props.impersonator }}
      />
    );
  }
}

RootScreen.propTypes = {
  isLoggedIn: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
  user: state.pState.user?.user,
  impersonator: state.pState.user?.impersonator,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RootScreen);
